import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { buildHref } from "@softmax/web-addresses";
import notFound from "./not-found.module.css";

export function ProductRouteNotFound() {
  return (
    <main id="main" data-shell-page tabIndex={-1} className={notFound.page}>
      <h1 className={notFound.title}>Page not found</h1>
      <a href={buildHref({ name: "browse" })} className={notFound.link}>
        Browse coworlds
      </a>
    </main>
  );
}

export function ProductRouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();
  const queryError = useQueryErrorResetBoundary();
  return (
    <main id="main" data-shell-page tabIndex={-1} role="alert">
      <h1>This page could not be loaded.</h1>
      <button
        onClick={() => {
          queryError.reset();
          reset();
          void router.invalidate();
        }}
      >
        Try again
      </button>
    </main>
  );
}
